/* PDP picture links — assets/pdp-image-links.js (ticket #1191, Hunter, 2026-10-21: "make URLs that
   are .jpgs open in the current tab as a pop-up box, instead of a new tab", e.g. the NVMP-E size chart).

   A link in the product info (description, Overview, the spec panels, the disclaimer) whose address
   is a picture file (.jpg / .jpeg / .png / .gif / .webp, anything after ? or # ignored) opens in a
   pop-up over the page instead of a new tab: picture fit to the screen, a title from the link text,
   Close (x, Esc, click outside) and "Open full size" for anyone who still wants the tab. Ctrl / Cmd /
   Shift / middle click, links with a download attribute, links inside the page's own pop-ups and
   links to PDFs or pages are left alone. If this file doesn't load, the stored link works as before.

   Loaded ONLY by sections/product-info.liquid. Self-contained: own CSS (injected once), no Font
   Awesome. Test: node scripts/tests/test-pdp-image-links.js */
(function () {
  'use strict';
  if (window.IDPSImageLinks) return;

  var SCOPE = '.pdp__info, .pdp__info-grid';
  var IMG_RE = /\.(jpe?g|png|gif|webp)$/i;

  function isPicture(a) {
    var href = a.getAttribute('href');
    if (!href || /^(javascript|mailto|tel|data):/i.test(href)) return false;
    var path;
    try { path = new URL(a.href, location.href).pathname; } catch (e) { return false; }
    return IMG_RE.test(path);
  }

  var CSS = [
    'html.pil-lock,html.pil-lock body{overflow:hidden!important}',
    '.pil{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:24px;',
    "font-family:var(--font-body,'DM Sans',system-ui,sans-serif)}",
    '.pil[hidden]{display:none}',
    '.pil__bg{position:absolute;inset:0;background:rgba(9,14,24,.72);opacity:0;transition:opacity .2s ease}',
    '.pil.is-open .pil__bg{opacity:1}',
    '.pil__box{position:relative;display:flex;flex-direction:column;max-width:min(1100px,100%);max-height:100%;background:#fff;color:#1f2933;',
    'border-radius:14px;box-shadow:0 24px 60px rgba(0,0,0,.35);overflow:hidden;transform:translateY(8px) scale(.98);opacity:0;',
    'transition:transform .22s cubic-bezier(.2,.8,.2,1),opacity .2s ease}',
    '.pil.is-open .pil__box{transform:none;opacity:1}',
    '.pil__bar{display:flex;align-items:center;gap:12px;padding:10px 10px 10px 18px;border-bottom:1px solid #e5e7eb}',
    '.pil__title{flex:1;min-width:0;font:600 15px/1.3 var(--font-heading,Montserrat,sans-serif);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.pil__full{font-size:13px;font-weight:600;color:#1a5fa8;text-decoration:none;white-space:nowrap}',
    '.pil__full:hover{text-decoration:underline}',
    '.pil__x{width:38px;height:38px;flex:none;border:0;border-radius:50%;background:#f1f5f9;color:#1f2933;cursor:pointer;',
    'display:inline-flex;align-items:center;justify-content:center;padding:0}',
    '.pil__x:hover{background:#e2e8f0}',
    '.pil__x svg{width:18px;height:18px;display:block}',
    '.pil__x:focus{outline:none}.pil__x:focus-visible,.pil__full:focus-visible{outline:3px solid #7fb4ef;outline-offset:2px}',
    /* the picture itself stays on white so charts drawn on white read normally in dark mode too */
    '.pil__stage{min-height:0;overflow:auto;display:flex;align-items:center;justify-content:center;background:#fff;padding:12px}',
    '.pil__img{display:block;max-width:100%;max-height:calc(100vh - 140px);width:auto;height:auto;object-fit:contain}',
    '.pil__img[hidden]{display:none}',
    '.pil__msg{padding:40px 24px;text-align:center;color:#5a6178;font-size:14px}',
    '.pil__msg[hidden]{display:none}',
    '@media (max-width:600px){.pil{padding:10px}.pil__img{max-height:calc(100vh - 110px)}}',
    '.dark .pil__box{background:#16202c;color:#e5edf6}',
    '.dark .pil__bar{border-color:#263445}',
    '.dark .pil__x{background:#22303f;color:#e5edf6}',
    '.dark .pil__x:hover{background:#2c3d50}',
    '.dark .pil__full{color:#7fb4ef}',
    '@media (prefers-reduced-motion:reduce){.pil__bg,.pil__box{transition:none}}'
  ].join('');

  var root, img, titleEl, fullEl, msgEl, closeBtn, lastFocus = null;

  function build() {
    if (root) return;
    var st = document.createElement('style');
    st.id = 'pil-css';
    st.textContent = CSS;
    document.head.appendChild(st);
    root = document.createElement('div');
    root.className = 'pil';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'pil-title');
    root.innerHTML =
      '<div class="pil__bg" data-pil-close></div>' +
      '<div class="pil__box">' +
        '<div class="pil__bar"><div class="pil__title" id="pil-title"></div>' +
          '<a class="pil__full" target="_blank" rel="noopener">Open full size</a>' +
          '<button type="button" class="pil__x" aria-label="Close" data-pil-close>' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button></div>' +
        '<div class="pil__stage"><img class="pil__img" alt="">' +
          '<div class="pil__msg" hidden>This picture couldn’t be loaded. Use “Open full size” to try it in a new tab.</div></div>' +
      '</div>';
    document.body.appendChild(root);
    img = root.querySelector('.pil__img');
    titleEl = root.querySelector('.pil__title');
    fullEl = root.querySelector('.pil__full');
    msgEl = root.querySelector('.pil__msg');
    closeBtn = root.querySelector('.pil__x');
    img.addEventListener('error', function () { if (img.getAttribute('src')) { img.hidden = true; msgEl.hidden = false; } });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-pil-close]')) close();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'Tab') {
        var f = [fullEl, closeBtn];
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
      }
    });
  }

  /* "Window_Cling_Info.jpg" → "Window Cling Info" (reopen of #1191: the raw file name read oddly).
     Drops the extension and the "_<uuid>" Shopify adds to a re-uploaded copy; _ and - become spaces. */
  function nameFromFile(f) {
    var t = String(f || '');
    try { t = decodeURIComponent(t); } catch (e) {}
    return t.replace(/\.[a-z0-9]{2,5}$/i, '')
      .replace(/[_-][0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '')
      .replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  /* Title order: meaningful link text → the link's own title / aria-label → alt text of a picture
     inside the link → the spec row's label ("Size") → the tidied file name. */
  function titleFor(a) {
    var t = clean(a.textContent);
    if (/^(click here|here|view|link|this|view here)$/i.test(t)) t = '';
    if (!t) t = clean(a.getAttribute('title') || a.getAttribute('aria-label'));
    if (!t) { var im = a.querySelector('img[alt]'); t = im ? clean(im.getAttribute('alt')) : ''; }
    if (!t) {
      var row = a.closest('.pdp__info-row');
      var label = row && row.querySelector('.pdp__info-label');
      t = label ? clean(label.textContent) : '';
    }
    if (!t) {
      try { t = nameFromFile(new URL(a.href, location.href).pathname.split('/').pop()); } catch (e) { t = ''; }
    }
    return t || 'Picture';
  }

  function open(a) {
    build();
    lastFocus = a;
    var t = titleFor(a);
    titleEl.textContent = t;
    fullEl.href = a.href;
    img.hidden = false;
    msgEl.hidden = true;
    img.alt = t;
    img.src = a.href;
    root.hidden = false;
    document.documentElement.classList.add('pil-lock');
    void root.offsetWidth;
    root.classList.add('is-open');
    closeBtn.focus();
  }

  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    root.hidden = true;
    img.removeAttribute('src');
    document.documentElement.classList.remove('pil-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.hasAttribute('download') || !a.closest(SCOPE) || a.closest('.pdp-modal')) return;
    if (!isPicture(a)) return;
    e.preventDefault();
    open(a);
  });

  window.IDPSImageLinks = { open: open, close: close, isPicture: isPicture, nameFromFile: nameFromFile };
})();
